module.exports = __webpack_public_path__ + "img/Avatar.f4ccfc63.jpeg";